import '../sass/main.scss';

import $ from 'jquery';
window.$ = window.jQuery = $;
import 'slick-carousel'; 
// import LazyLoad from 'vanilla-lazyload';
import mouseInit from "./demo3.js";
import { CountUp } from 'countup.js';

var siteGlobal = {
  initReady: function () {
    if ($(window).outerWidth(true) > 1200) {
      new mouseInit();
    }
  },
  initLoad: function () {
  	// this.lazyLoad();
    this.setHeight();
    this.langsMenu();
    this.sectionActivation();
    this.menuInit();
    this.countUpInit();
    setTimeout(function(){
      siteGlobal.typedInit();
    }, 1000);
    this.introToggle();
    this.servToggle();
    this.homeGallery();
    this.teamGal();
    this.serviziAnim();
    this.professionistiAnim();
    this.approccioAnim();
  },
  resize: function(){
    this.teamGal();
    if ($(window).outerWidth(true) > 1200) {
      new mouseInit();
    }
  },
  initScroll: function(){
    this.headerScroll();
    this.sectionActivation();
  },
  lazyLoad: function(){
    var ll = new LazyLoad({
        elements_selector: '.lazy',
        use_native: true
    })
  },
  sectionActivation: function(){
    if ($('.page_home').length) {
      $('[data-scroll-section]').each(function(){
        var winScroll = window.pageYOffset,
            scrollPerc = $(this).data('offset'),
            secPos = ($(this).offset().top / scrollPerc);
        if (winScroll < 30) {
            $('html').removeClass('color-white color-blue color-grey color-bronze');
            $('html').addClass('color-white');
        } else {
          if (winScroll - secPos > 0) {
            var col = $(this).data('color');
            $(this).removeClass('water').addClass('fire') 
            $('html').removeClass('color-white color-blue color-grey color-bronze');
            $('html').addClass('color-' + $(this).data('color'));
          } else {
            $(this).removeClass('fire').addClass('water');
          }
        }
      })
    }
  },
  sectionFired: function(){
    $('.pageIntro, .approccio, .team, .cont, .newsArch').addClass('fire');
  },
  headerScroll:function(){
    var winScroll = window.pageYOffset;
    if (winScroll > 30) {
      $('.header').addClass('scrolled');
    } else if (winScroll < 30) {
      $('.header').removeClass('scrolled');
    }
  },
  menuInit: function(){
    $('.header__hamburger').on('click', function(){
      $('.header__hamburger, .header, .header__nav').toggleClass('opened');
      $('.header__nav').fadeToggle(200);
    })
  },
  langsMenu: function(){
    $('.header__langs').on('click', function(){
      $(this).find('.arrow').toggleClass('rot');
      $(this).find('.lang-sub-menu').fadeToggle(150);
    })
  },
  wordSplit: function(){
    Splitting({
      target: '[data-splitting]',
      by: 'words'
    });
  },
  countUpInit: function(){
    if ($('#odometer-0').length) { 
      const options = {
        duration: 3,
        separator: '.',
        decimal: ',',
      };

      var topH = $('.homeVis').outerHeight(true),
          azH = $('.homeAz').outerHeight(true),
          spH = $('.homeSpec').outerHeight(true),
          specGalH = $('.homeAz__nums').outerHeight(true),
          numsH = $('.homeGal').outerHeight(true),
          heightBlocks = topH + azH + spH + specGalH + (numsH * 0.32),

          num1 = $('#odometer-0').data('num'),
          num2 = $('#odometer-1').data('num'),
          num3 = $('#odometer-2').data('num'),
          num4 = $('#odometer-3').data('num'),
          num5 = $('#odometer-4').data('num'),
          num6 = $('#odometer-5').data('num'),
          num7 = $('#odometer-6').data('num'),
          num8 = $('#odometer-7').data('num'),

          demo = new CountUp('odometer-0', num1, options),
          demo1 = new CountUp('odometer-1', num2, options),
          demo2 = new CountUp('odometer-2', num3, options),
          demo3 = new CountUp('odometer-3', num4, options),
          demo4 = new CountUp('odometer-4', num5, options),
          demo5 = new CountUp('odometer-5', num6, options),
          demo6 = new CountUp('odometer-6', num7, options),
          demo7 = new CountUp('odometer-7', num8, options);

      var position = $(window).scrollTop(); 
      
      $(window).on('scroll', function() {
        var scroll = $(window).scrollTop(); 

        /* Scroll verso il basso e scroll verso alto differenziati
        perchè altrimenti il reset risalendo mostrerebbe troppo
        presto lo 0 */
        
        if (scroll > position) { 
          if (scroll > heightBlocks && scroll < heightBlocks + $(window).outerHeight(true) * 2) {  
            demo.start();
            demo1.start();
            demo2.start();
            demo3.start();
            demo4.start();
            demo5.start();
            demo6.start();
            demo7.start();
          } else {
            /*demo.reset();
            demo1.reset();
            demo2.reset();
            demo3.reset();
            demo4.reset();
            demo5.reset();
            demo6.reset();
            demo7.reset();*/
          }
        } else { 
          if (scroll > (heightBlocks - $(window).outerHeight(true)) && scroll < heightBlocks + $(window).outerHeight(true) * 2) {  
            demo.start();
            demo1.start();
            demo2.start();
            demo3.start();
            demo4.start();
            demo5.start();
            demo6.start();
            demo7.start();
          } else {
            // demo.reset();
            // demo1.reset();
            // demo2.reset();
            // demo3.reset();
            // demo4.reset();
            // demo5.reset();
            // demo6.reset();
            // demo7.reset();
          }
        } 

        position = scroll; 

      });
    }
  },
  typedInit: function(){
    $('.homeVis .homeBlock__title').each(function(){
      var speed = ($(window).outerWidth(true) > 991) ? 10 : 1;
      var tit = $(this).data('title'),
          options = {
            strings: [tit],
            typeSpeed: speed,
            showCursor: false,
          },
          typed = new Typed($(this)[0], options);
    })
  },
  setHeight: function(){
    // if ($('.page_home').length) {
      setTimeout(function(){  
        var height = $('#main_cont').outerHeight(true);
        $('body').css('height', height+'px');
      }, 1000)
    // }
  },
  homeGallery: function(){
    $('.homeGal__box').each(function(){
      var controller = new ScrollMagic.Controller(),
          tl = new TimelineMax(),
          galBlock = $(this).find('.homeGal__curtain');
         
      var apprAnim = tl.to(galBlock, .7, {left:"100%"}, .2);

      var scene2 = new ScrollMagic.Scene({reverse: true, triggerElement: $(this).find('.homeGal__trig')[0]}).setTween(apprAnim).addTo(controller);
    })
  },
  introToggle: function(){
    $('.pageIntro__trig').on('click', function(){
      var htmlLang = $('html').attr('lang');
      var readMoreLabel = (htmlLang == 'it') ? 'Leggi tutto' : 'Read all';
      var closeLabel = (htmlLang == 'it') ? 'Chiudi' : 'Close';

      $('.pageIntro__toggle').slideToggle(500, function() {

        $(this).parent().find('.pageIntro__trig').toggleClass('toggled');

        var btn = document.getElementById("trig");
        if($(this).parent().find('.pageIntro__trig').hasClass('toggled')) btn.innerHTML = closeLabel;
        else btn.innerHTML = readMoreLabel;

        siteGlobal.setHeight();
      });
    })
  },
  servToggle: function(){
    $('.servList__trig').on('click', function(){
      $(this).parent().toggleClass('active');
      $(this).siblings('.servList__cont').slideToggle(400);
      siteGlobal.setHeight();
    })
  },
  teamGal: function(){
    if ($('.teamGal__gall').length) { 
      $('.teamGal__gall').not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 4500,
        lazyLoad: 'ondemand',
        speed: 800,
        infinite: true,
        adaptiveHeight: true
      });
    }
  },
  serviziAnim: function(){
    var controller = new ScrollMagic.Controller(),
        tl = new TimelineMax(),
        servBlocks = $('.servList__block');
       
    var servAnim = tl.staggerTo(servBlocks, .4, {top:0, opacity:1, ease: Sine.easeOut}, .2);

    var scene2 = new ScrollMagic.Scene({reverse: true, triggerElement: $('#serv_trig')[0], triggerHook: 0.8}).setTween(servAnim).addTo(controller);
  },
  professionistiAnim: function(){
    var controller = new ScrollMagic.Controller(),
        tl = new TimelineMax(),
        teamBlocks = $('.page_chi .homeSpec__el, .page_chi_siamo .homeSpec__el');
       
    var servAnim = tl.staggerTo(teamBlocks, .4, {top:0, opacity:1, ease: Sine.easeOut}, .2);

    var scene2 = new ScrollMagic.Scene({reverse: true, triggerElement: $('#team_trig')[0]}).setTween(servAnim).addTo(controller);
  },
  approccioAnim: function(){
    $('.approccio__block').each(function(){
      var controller = new ScrollMagic.Controller(),
          tl = new TimelineMax(),
          apprBlock = $(this);
         
      var apprAnim = tl.to(apprBlock, .4, {top:0, opacity:1, ease: Sine.easeOut}, .2);

      var scene2 = new ScrollMagic.Scene({reverse: true, triggerElement: $(this).find('.approccio__trig')[0]}).setTween(apprAnim).addTo(controller);
    })
  },
  rebuildAllEvents: function(){
    $('.homeVis, .pageIntro, .approccio, .team, .cont, .schedaSpec, .newsArch').removeClass('water').addClass('fire');
    this.initLoad();
  },
};

global.siteGlobal = siteGlobal;


(function () {
  siteGlobal.initReady();
  $(window).on('load', function() {
    setTimeout(function(){
      $('#preloader').addClass('loaded');
      $('.homeVis, .pageIntro, .approccio, .team, .cont, .schedaSpec, .newsArch').removeClass('water').addClass('fire');
    }, 600)
    siteGlobal.initLoad();
  });

  $(window).on('scroll', function(){
    siteGlobal.initScroll();
  })

  $(window).on('resize', function(){
    siteGlobal.resize();
  })

}());